module.exports = "/build/images/plusButton.svg?5cd3cce41ce97f873f79a29a6839d650";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/plusButton.svg
// module id = 2439
// module chunks = 0